const template = `
  query StylistReviews($queryType: ReviewQueryType! ,$queryParams: ReviewQueryParams!) {
    reviews(
        type: booking,
        queryType: $queryType,
        queryParams: $queryParams,
        input: {limit: 3, offset: 0}
    ) {
      id
      user {
        id
        name
        avatar
      }
      review
      rating
      createdAt
      photos {
        url {
          large
          small
        }
      }
      booking {
        services {
          service {
            name
          }
        }
        stylistUser {
          id
          name
          avatar
        }
        studio {
          address
        }
        bookingDiscount {
          campaign {
            name
          }
        }
      }
    }
  }
`

export default async function stylistReviews({ queryType, queryParams }) {
  const { reviews } = await request(template, { queryType, queryParams })
  return reviews
}
